import { IMAGE_MODE } from "../../constants/imageMode"

export const breakpointsWidth = {
    desktop: 1378,
    tab_port: 998,
    tab_medium: 625,
    phone: 0
}

export const slidesBreakpoints = {
    [IMAGE_MODE.THUMB]: {
        [breakpointsWidth.desktop]: {
            slidesPerView: 5,
            slidesPerGroup: 5,
        },
        [breakpointsWidth.tab_port]: {
            slidesPerView: 5,
            slidesPerGroup: 5,
        },
        [breakpointsWidth.tab_medium]: {
            slidesPerView: 4,
            slidesPerGroup: 4,
        },
        [breakpointsWidth.phone]: {
            slidesPerView: 2.6,
            slidesPerGroup: 2.6,
        }
    },
    [IMAGE_MODE.POSTER]: {
        [breakpointsWidth.desktop]: {
            slidesPerView: 5,
            slidesPerGroup: 5,
        },
        [breakpointsWidth.tab_port]: {
            slidesPerView: 5,
            slidesPerGroup: 5,
        },
        [breakpointsWidth.tab_medium]: {
            slidesPerView: 4,
            slidesPerGroup: 4,
        },
        [breakpointsWidth.phone]: {
            slidesPerView: 2.6,
            slidesPerGroup: 2.6,
        }
    },
    [IMAGE_MODE.SIMPLE_LARGE]: {
        [breakpointsWidth.desktop]: {
            slidesPerView: 4,
            slidesPerGroup: 4,
        },
        [breakpointsWidth.tab_port]: {
            slidesPerView: 3,
            slidesPerGroup: 3,
        },
        [breakpointsWidth.tab_medium]: {
            slidesPerView: 3,
            slidesPerGroup: 3,
        },
        [breakpointsWidth.phone]: {
            slidesPerView: 2,
            slidesPerGroup: 2,
        }
    }
}


export const loopAdditionalSlides = {
    [IMAGE_MODE.THUMB]:{
        desktop: 5,
        tab_port: 4,
        tab_medium: 2.6,
        phone: 2.6
    },
    [IMAGE_MODE.SIMPLE_LARGE]:{
        desktop: 3,
        tab_port: 3,
        tab_medium: 2,
        phone: 2
    },
    [IMAGE_MODE.POSTER]:{
        desktop: 5,
        tab_port: 4,
        tab_medium: 2.6,
        phone: 2.6
    }

}